/* [Modified by Codex at 2026-10-15] 保持左侧缩略图滚动适配可调尺寸、间距和变体重排 */
if (!customElements.get('product-thumbnail-slider')) {
  customElements.define(
    'product-thumbnail-slider',
    class ProductThumbnailSlider extends SliderComponent {
      get isVertical() {
        return window.matchMedia('(min-width: 750px)').matches;
      }

      connectedCallback() {
        this.viewer = this.closest('media-gallery')?.querySelector('[id^="GalleryViewer-"]');
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.onLayoutChange = () => {
          this.slider.scrollTo({ top: 0, left: 0, behavior: 'instant' });
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.syncViewerHeight());
        };
        this.mediaQuery.addEventListener('change', this.onLayoutChange);
        this.viewerResizeObserver = new ResizeObserver(() => this.syncViewerHeight());
        if (this.viewer) this.viewerResizeObserver.observe(this.viewer);
        this.syncViewerHeight();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.layoutFrame);
        this.viewerResizeObserver?.disconnect();
        this.mediaQuery?.removeEventListener('change', this.onLayoutChange);
      }

      syncViewerHeight() {
        if (this.viewer && this.isVertical) {
          this.style.setProperty('--product-thumbnail-height', `${this.viewer.clientHeight}px`);
        } else {
          this.style.removeProperty('--product-thumbnail-height');
        }
        this.initPages();
        const selected = this.querySelector('button[aria-current="true"]')?.closest('[data-target]');
        if (selected) this.scrollToSlide(selected, 'instant');
      }

      initPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        if (!this.isVertical) return super.initPages();
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
        this.sliderItemOffset = this.sliderItemsToShow.length > 1
          ? this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop
          : this.sliderItemsToShow[0]?.clientHeight || 1;
        this.update();
      }

      update() {
        if (!this.isVertical) return super.update();
        if (!this.slider || !this.nextButton || !this.sliderItemsToShow?.length) return;
        this.prevButton.disabled = this.slider.scrollTop <= 1;
        this.nextButton.disabled = this.slider.scrollTop + this.slider.clientHeight >= this.slider.scrollHeight - 1;
      }

      isSlideVisible(element, offset = 0) {
        if (!this.isVertical) return super.isSlideVisible(element, offset);
        if (!element) return false;
        return element.offsetTop >= this.slider.scrollTop + offset &&
          element.offsetTop + element.clientHeight <= this.slider.scrollTop + this.slider.clientHeight - offset;
      }

      onButtonClick(event) {
        if (!this.isVertical) return super.onButtonClick(event);
        event.preventDefault();
        this.initPages();
        const step = Number(event.currentTarget.dataset.step) || 1;
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        this.slider.scrollTo({ top: this.slider.scrollTop + direction * step * this.sliderItemOffset });
      }

      scrollToSlide(thumbnail, behavior = 'auto') {
        if (this.isSlideVisible(thumbnail)) return;
        if (this.isVertical) {
          this.slider.scrollTo({ top: Math.max(0, thumbnail.offsetTop - 5), behavior });
        } else {
          this.slider.scrollTo({ left: thumbnail.offsetLeft, behavior });
        }
      }
    }
  );
}
/* [End] */
